import {MessageBox} from 'element-ui';
import storage from 'local-storage-fallback';
import {showError} from '../utils/msg';
import {isNull, isMobile, buttonHelper} from '../utils/helper';
import httpclient from '../utils/httpclient';
import store from '../store';

function getSession() {
  const sessionString = storage.getItem('sp_session');
  if (!sessionString) {
    return null;
  }

  const session = JSON.parse(sessionString);
  if (!session || !session.access_token) {
    return null;
  }

  return session;
}

function extractAccessToken() {
  const session = getSession();
  if (!session) {
    return null;
  }
  return session.access_token;
}

function url_base64_decode(str) {
  let output = str.replace(/-/g, '+').replace(/_/g, '/');
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += '==';
      break;
    case 3:
      output += '=';
      break;
    default:
      throw 'Illegal base64url string!';
  }
  const result = window.atob(output);
  try {
    return decodeURIComponent(escape(result));
  } catch (err) {
    return result;
  }
}

function delete_cookie(name) {
  document.cookie = name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function getAuthInfo() {
  const accesstoken = extractAccessToken();
  if (!accesstoken) {
    logoutAndShowLogin();
    return null;
  }

  const accessTokenParts = accesstoken.split('.');
  const jwt = JSON.parse(url_base64_decode(accessTokenParts[1]));

  if (jwt.exp < Date.now() / 1000) {
    logoutAndShowLogin();
    return null;
  }

  if (!jwt.tsp) {
    logoutAndShowLogin();
    return null;
  }

  jwt.access_token = accesstoken;
  return jwt;
}

function removeSession() {
  storage.removeItem('sp_session');
  delete_cookie('.AspNetCore.Identity.Application');
  delete_cookie('idsrv.session');
}

export function logoutAndShowLogin() {
  removeSession();

  if (process.env.NODE_ENV !== 'production') {
    if (location.hash && location.hash.indexOf('#/dev-login') === 0) {
      return;
    }
    window.location.href = '/#/dev-login?hidetopbar=1&hideleftbar=1';
    return;
  }

  const windowWidth = $(window).width();
  if (windowWidth <= 430) {
    window.location.href = location.hostname.indexOf('yihulu.com') > -1 ? process.env.BASE_API_2 : process.env.BASE_API + '/login.html';
    return;
  }

  layer.open({
    type: 2,
    shade: 0.8,
    title: false,
    fixed: false,
    area: ['400px', '500px'],
    content: '/login.html'
  });
}

export function logout() {
  MessageBox.confirm('确定要退出系统吗?', '请确认', {center: true}).then(function () {
    removeSession();
    if (store.state.invite.sub_domain_name && store.state.invite.sub_domain_name.length) {
      window.location.href = `https://${store.state.invite.sub_domain_name}.${(location.hostname.indexOf('yihulu.com') > -1 ? process.env.BASE_DOMAIN_2 : process.env.BASE_DOMAIN)}`;
    } else {
      window.location.href = '/';
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/auth.js